export default __webpack_public_path__ + "static/media/Db_6.533dd703.png";